import styles from './PeriodInformation.css'
import cx from 'classnames'

export const PeriodInformation = props => {
  const {
    children,
    className,
    noPaddingTop,
    ...otherProps
  } = props

  const clz = cx(
    styles.period,
    { [className]: !!className },
    { [styles.noPaddingTop]: noPaddingTop }
  )

  return (
    <div
      className={clz}
      {...otherProps}
    >
      {children}
    </div>
  )
}
